import React, { useState } from 'react';
import {
	makeStyles,
	TextField,
	FormControlLabel,
	useMediaQuery,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	container: {
		placeItems: 'normal',
		maxWidth: ({ isMobile }) => isMobile && '100%',
		width: ({ isMobile, width }) => (isMobile ? '100%' : width),
		margin: 0,
	},
	label: {
		minWidth: 120,
		marginRight: 10,
		color: ({ disabled, touched, hover }) =>
			(touched || hover) && !disabled ? theme.palette.primary.main : 'black',
	},
}));

export const NormalInput = (props) => <input {...props} />;

export const TextareaInput = (props) => <textarea {...props} />;

const SimpleText = ({
	label,
	labelPos = 'top',
	placeholder,
	helperText,
	name,
	onChange = () => {},
	onKeyPress = () => {},
	onBlur = () => {},
	value,
	disabled = false,
	width = '100%',
	multiline,
	maxLength,
	rows,
	required = false,
	autoComplete = 'off',
	isPassword = false,
	isNumber = false,
	decimals = 0,
	style = {},
	containerClass = '',
	adjust = false,
	adjustable = false,
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [touched, setTouched] = useState(false);
	const [hover, setHover] = useState(false);
	const classes = useStyles({ isMobile, disabled, width, touched, hover });
	return (
		<FormControlLabel
			className={classes.container + ` ${containerClass}`}
			label={<p className={classes.label}>{label}</p>}
			labelPlacement={isMobile ? 'top' : labelPos}
			control={
				<TextField
					fullWidth
					style={style}
					autoComplete={autoComplete}
					size="small"
					variant="outlined"
					type={isPassword ? 'password' : isNumber ? 'number' : 'text'}
					placeholder={placeholder ? placeholder : label}
					helperText={helperText ? helperText : ''}
					name={name}
					onChange={onChange}
					onKeyPress={onKeyPress}
					value={value}
					disabled={disabled}
					multiline={adjustable || multiline}
					rows={rows}
					required={required}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					onBlur={onBlur}
					onFocus={(e) => setTouched(true)}
					InputProps={{
						inputProps: {
							decimals,
							maxLength,
						},
					}}
				/>
			}
		/>
	);
};

export default SimpleText;
